/**
 * `rankingScale: null` = máximo desconocido (pregunta borrada del CMS después de responderla, TANAI-2575): se da
 * por correcta si sacó puntos, el mismo criterio con el que se guarda `isCorrect` en `job.data`.
 */
export const getResultStatus = (isEvaluable, rankingScale, score, answer) => {
  if (!isEvaluable) return answer ? 'done' : 'notDone';
  if (rankingScale === null) return score > 0 ? 'correct' : 'incorrect';
  return score === rankingScale ? 'correct' : 'incorrect';
};

export const getQuestionStatusInfo = (data, ranking_scale, score, answer, viewed_solution_at) => ({
  result: getResultStatus(_getData(data)?.data?.isEvaluable, ranking_scale, score, answer),
  isViewed: !!viewed_solution_at,
});

export const getQuestionStatus = (data, ranking_scale, score, answer, viewed_solution_at) => {
  const { result, isViewed } = getQuestionStatusInfo(data, ranking_scale, score, answer, viewed_solution_at);
  return ['quizz-results-bullets--' + result, 'quizz-results-bullets--viewed-status-' + (isViewed ? 'viewed' : 'not-viewed')];
};

const RESULT_LABEL_KEYS = {
  correct: 'test:Question status correct',
  incorrect: 'test:Question status incorrect',
  done: 'test:Question status answered',
  notDone: 'test:Question status not answered',
};

/** Estado de la pregunta en texto («correcta, vista») para el nombre accesible de su botón: el color no basta. */
export const getQuestionStatusLabel = (t, { result, isViewed }) => {
  const resultKey = RESULT_LABEL_KEYS[result];
  const viewedLabel = t(isViewed ? 'test:Question status viewed' : 'test:Question status not viewed');
  return resultKey ? `${t(resultKey)}, ${viewedLabel}` : viewedLabel;
};

function _getData(data) {
  let newData = data;
  try {
    newData = JSON.parse(data);
    if (!newData.data) {
      newData = {
        type: newData.type,
        metadata: newData.metadata,
        reference: newData.question_guid,
        data: newData,
      };
    }
  } catch {
    // Si falla el parse, mantener los datos originales
  }
  return newData;
}
